import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles/StyleSheet'
import DealSheetCard from 'components/deal_sheet/DealSheetCard'
import Carousel, { CarouselItem } from 'components/Carousel'

export class DealsCarousel extends Component{

  static propTypes = {
    dealSheets:     PropTypes.array.isRequired,
    cardProps:      PropTypes.object,
    carouselProps:  PropTypes.object,
    size:           PropTypes.number
  }

  static defaultProps = {
    cardProps: {},
    carouselProps: {}
  }

  render = () =>
    <Carousel
      className={
        styles('dealCarousel', {
          'one_up'  : this.props.carouselProps.size === 1,
          'two_up'  : this.props.carouselProps.size === 2,
          'three_up': this.props.carouselProps.size === 3
        })}
      {...this.props.carouselProps}
      >
        {
          this.props.dealSheets.map(ds =>
            <CarouselItem key={ds.id}>
              <DealSheetCard {...this.props.cardProps} dealSheet={ds}/>
            </CarouselItem>
          )
        }
    </Carousel>
}

const styles = StyleSheet({
  'one_up' : {
    justifyContent: 'space-between',
    '& > div': {
      width: '100%',
      maxWidth: 'none'
    },
    '& > div:first-child': {
      marginLeft: 0
    },

    '& > div:last-child': {
      marginRight: 0
    }
  },
  'two_up' : {
    justifyContent: 'space-between',
    '& > div': {
      width: '47%',
      margin: '0 1%',
      maxWidth: 'none'
    },
    '& > div:first-child': {
      marginLeft: 0
    },

    '& > div:last-child': {
      marginRight: 0
    }
  },
  'three_up' : {
    justifyContent: 'space-between',
    '& > div': {
      width: '31%',
      margin: '0 1%',
      maxWidth: 'none'
    },
    '& > div:first-child': {
      marginLeft: 0
    },

    '& > div:last-child': {
      marginRight: 0
    }
  },
  dealCarousel: {
    fontFamily: 'Montserrat,sans-serif',
    display: 'flex',
    flexDirection: 'row',
    '& > div': {
      width: '22%',
      margin: 0,
      marginRight: '1%',
    },
    '@media(max-width: 1600px)':{
      '& > div': {
        width: '32%',
        marginRight: '2%'
      }
    },
    '@media(max-width: 1080px)':{
      '& > div': {
        width: '50%',
        marginRight: '3%',
        maxWidth: '670px'
      }
    },
    '@media(max-width: 1020px)':{
      '& > div': {
        width: '50%',
        marginRight: '1%'
      }
    },
    '@media(max-width: 670px)':{
      '& > div': {
        width: '100%',
        maxWidth: '670px'
      }
    }
  }
})

export default DealsCarousel